export const sectionTypes = {
    FEATURES: "features",
    SUPPORT: "support",
    DATA: "data"
};